import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { ErrorModel } from '../models/error.model';
import { FiniteStateMachineModel } from '../models/finiteStateMachines/finite-state-machine.model';
import { AuthMyfileService } from './auth.myfile.service';
import { BaseApiService } from './base-api.service';
import { FSMListState } from './list-services/finite-state-machine-list.service';
import { ToasterNotificationService } from './toaster-notification.service';
import { environment } from 'src/environments/environment';
import { SearchResultModel } from '../models/query/search-result-model';
import { HttpClient } from '@angular/common/http';

const MYFILE_AI_URL = `${environment.aiApiUrl}`;

@Injectable({
  providedIn: 'root'
})
export class FsmApiService extends BaseApiService {

  
    constructor(
        private http: HttpClient,
        private authMyfileService: AuthMyfileService,
        override toasterNotificationService: ToasterNotificationService
    ) {
        super(toasterNotificationService);
    }

  getFiniteStateMachinesList(search: FSMListState): Observable<SearchResultModel<FiniteStateMachineModel> | undefined> {
      const url = `${MYFILE_AI_URL}/FiniteStateMachines`;
      return this.http.post<SearchResultModel<FiniteStateMachineModel>>(url, JSON.stringify(search)).pipe(
        catchError(err => this.handleError(err))
      );
    }
  
    updateFiniteStateMachines(machine: FiniteStateMachineModel): Observable<boolean | undefined> {
      const url = `${MYFILE_AI_URL}/FiniteStateMachines/${machine.id}`;
      return this.http.put<boolean>(url, JSON.stringify(machine), { observe: 'response' })
        .pipe(
          map(data => {
            if (data.status == 200) {
              return true;
            }
            if (data.status == 204) {
              return true;
            }
            return false;
          }),
          catchError(err => this.handleError(err))
        )
    }
  
    newFiniteStateMachines(machine: FiniteStateMachineModel): Observable<boolean | undefined> {
      const url = `${MYFILE_AI_URL}/FiniteStateMachines/new`;
      return this.http.post<boolean>(url, JSON.stringify(machine), { observe: 'response' })
        .pipe(
          map(data => {
            if (data.status == 200) {
              return true;
            }
            if (data.status == 204) {
              return true;
            }
            return false;
          }),
          catchError(err => this.handleError(err))
        );
    }
  
    getFiniteStateMachines(requisitionId: string) {
      const url = `${MYFILE_AI_URL}/FiniteStateMachines/${requisitionId}`;
      return this.http.get<FiniteStateMachineModel>(url)
        .pipe(
          catchError(err => this.handleError(err))
        );
    }
  
    deleteFiniteStateMachines(modelId: string): Observable<boolean | undefined> {
      const url = `${MYFILE_AI_URL}/FiniteStateMachines/${modelId}`;
      return this.http.delete<ErrorModel | boolean>(url, { observe: 'response' })
        .pipe(
          map(data => {
            if (data && data.status == 200) {
              return true;
            }
            this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
            return false;
          }),
          catchError(err => this.handleError(err))
        );
    }
}
